import { DOMSerializer, Fragment, Schema } from 'prosemirror-model'
/*
 * Serialize a Prosemirror Fragment to an HTML string.
 * When fragment is not given, an empty fragment is serialized instead.
 */
export const serializeFragmentToHTMLString = (fragment: Fragment | undefined, schema: Schema): string => {
  const htmlContent = DOMSerializer.fromSchema(schema).serializeFragment(fragment || Fragment.empty)
  let tmp = document.createElement('div')
  tmp.appendChild(htmlContent)
  return tmp.innerHTML
}
